import { themeBalham } from 'ag-grid-community';

export const esraTheme = themeBalham.withParams({
  headerFontSize: '11.2px',
  headerFontWeight: 700,
  headerTextColor: '#141414',
  foregroundColor: '#141414',
  headerBackgroundColor: '#f2f2f2',
  inputBorder: {
    color: '#141414',
    width: 1,
    style: 'solid',
  },
  inputBorderRadius: 0,
  inputHeight: '13px',
  backgroundColor: '#fff',
  fontSize: '11.2px',
  fontFamily: 'PwC Helvetica Neue, Helvetica Neue, sans-serif',
  checkboxCheckedBackgroundColor: '#d04a02',
  checkboxCheckedShapeColor: '#fff',
  checkboxCheckedBorderColor: '#d04a02',
});
